const ConcreteEmissionType = {
	"material": {
		"accelerator": 0.000,
		"air": 0.000,
		"airEntrainingMixture": 0.000,
		"crushedCoarseAggregate": 0.000,
		"crushedFineAggregate": 0.000,
		"flyAsh": 0.000,
		"highRangeWaterReducer": 0.000,
		"mixingWater": 0.000,
		"naturalCoarseAggregate": 0.000,
		"naturalFineAggregate": 0.000,
		"portlandCement": 0.000,
        "slagCement": 0.000,
		"waterReducer": 0.000,
		"total": 0.000
	},
	"energy": {
		"purchasedElectricity": 0.000,
        "naturalGas": 0.000,
        "secondaryFuelLiquid": 0.000,
        "secondaryFuelSolid": 0.000,
        "fuelOil": 0.000,
        "diesel": 0.000,
        "gasoline":	0.00,
        "lpg": 0.000,
		"total": 0.000
	},
	"transportation": {
		"crushedCoarseAggregate": 0.000,
		"crushedFineAggregate": 0.000,
        "naturalCoarseAggregate": 0.000,
		"naturalFineAggregate": 0.000,
		"flyAsh": 0.000,
        "slagCement": 0.000,
		"total": 0.000
	},
	"factor": {
        "material": {
            "portlandCement": 0.903,
            "flyAsh": 0.012,
            "slagCement": 0.193,
            "mixingWater": 0.000,
            "crushedCoarseAggregate": 0.004,
            "naturalCoarseAggregate": 0.002,
            "crushedFineAggregate": 0.004,
            "naturalFineAggregate": 0.002,
            "air": 0.000,
            "airEntrainingMixture": 0.527,
            "waterReducer": 1.880,
            "highRangeWaterReducer": 1.880,
            "accelerator": 1.330
        },
        "energy": {
            "purchasedElectricity": 0.435,
            "naturalGas": 6.932,
            "secondaryFuelLiquid": 0.000,
            "secondaryFuelSolid": 0.000,
            "fuelOil": 4.965,
            "diesel": 2.664,
            "gasoline": 2.322,
            "lpg": 1.986
        },
        "transportation": {
            "truck": 0.081,
            "rail": 0.060,
            "ocean": 0.012,
            "barge": 0.012
        }
    },
	"total": 0.000
}

export default ConcreteEmissionType;